import { useTranslations } from 'next-intl';
import { CatPopover } from 'components/blocks-components';
import { useState } from 'react';
import ContactDealerPopoverContent from 'components/contact-your-dealer/contact-dealer-popover-content/contact-dealer-popover-content';

export const ContactDealerPopover = ({ storeAddress, children }) => {
  const t = useTranslations();
  const [showContactDealerPopup, setShowContactDealerPopup] =
    useState(undefined);

  return (
    <div className="d-inline-block">
      <CatPopover
        heading={t('FOOTER_CONTACT_US')}
        position="bottom"
        behavior="responsive"
        isActive={showContactDealerPopup}
        onBlPopoverOpen={() => setShowContactDealerPopup(true)}
        onBlPopoverClose={() => setShowContactDealerPopup(false)}
      >
        <span slot="trigger">{children}</span>
        <ContactDealerPopoverContent
          dealerAddress={storeAddress}
          locale={storeAddress?.locale}
          isLowerCaseLinkText
        />
      </CatPopover>
    </div>
  );
};
